// @flow
import React from 'react';
// graphql
import { createFragmentContainer, graphql } from 'react-relay';
import { withRouter } from 'react-router-dom';
// material
import Paper from 'material-ui/Paper';
import FlatButton from 'material-ui/FlatButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
// topic list
import TopicList from './TopicsList';
// style
import '../ui/column.css';
import './topics.css';
import { styles } from '../../lib/styles';

type Props = {
    viewer?: string,
    history: Object,
};

class TopicsApp extends React.Component<Props> {
    renderNewTopicBtn = () => (
        <FlatButton
            label="Создать тему"
            className="topics--button"
            style={styles.headerButton}
            primary
            icon={<ContentAdd />}
            onClick={() => this.props.history.replace('/topic/new')}
        />
    );

    render() {
        return (
            <section className="topics column-wrapper">
                <Paper className="column--1-1">
                    <header className="column--header">
                        <h3 className="column--title-regular">Темы</h3>
                        {this.renderNewTopicBtn()}
                    </header>
                    <TopicList viewer={this.props.viewer} />
                </Paper>
            </section>
        );
    }
}


export default withRouter(createFragmentContainer(
    TopicsApp,
    graphql`
        fragment TopicsApp_viewer on Viewer @argumentDefinitions(section: {type: "ID!",}) {
            ...TopicsList_viewer,
        }
    `,
));



// WEBPACK FOOTER //
// src/components/topics/TopicsApp.js